import { render } from "./serial.vue?vue&type=template&id=9ce83f48"
import script from "./serial.vue?vue&type=script&lang=js"
export * from "./serial.vue?vue&type=script&lang=js"

import "./serial.vue?vue&type=style&index=0&id=9ce83f48&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__